import { useQuery } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
/**
 * Fetch CLINs (Contract Line Item Numbers) for a proposal project
 */ export function useCLINs(projectId) {
    return useQuery({
        queryKey: [
            'clins',
            projectId
        ],
        queryFn: ()=>proposalProjectApiConnect.getCLINs(projectId),
        staleTime: 60000,
        enabled: !!projectId,
        retry: 1,
        placeholderData: {
            clins: [],
            stats: {
                totalCLINs: 0,
                baseCLINs: 0,
                optionCLINs: 0,
                totalValue: 0,
                fundedValue: 0
            }
        }
    });
}
